import icon from 'vue-svgicon';

icon.register({
    'regular/flag-plain-3': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M.75 23.25V.75M.75 17.708l3.154-.97a9.61 9.61 0 0 1 7.864 1 9.615 9.615 0 0 0 7.679 1.062l2.987-.854a1.125 1.125 0 0 0 .816-1.082V5.137a1.126 1.126 0 0 0-1.434-1.082l-2.369.677a9.615 9.615 0 0 1-7.679-1.056 9.61 9.61 0 0 0-7.864-1L.75 3.645"/>`,
    },
});
